import styles from './ImageIcon.module.scss';

function ImageIcon({
  imgSrc,
  size = 'default',
  badgeCount = 0,
}: {
  imgSrc: string;
  size?: 'small' | 'default';
  badgeCount?: number;
}) {
  return (
    <div className={styles.componentStyle}>
      <img src={imgSrc} alt='icon' className={`${styles[`${size}Image`]}`} />
      {badgeCount > 0 && (
        <div className={`${styles.countBadge} ${styles[`${size}Badge`]} ${badgeCount > 99 ? styles.badgeOver99 : ''}`}>
          {badgeCount > 99 ? '99+' : badgeCount}
        </div>
      )}
    </div>
  );
}
export default ImageIcon;
